import React from 'react'; 
import { Link } from 'react-router-dom';

import {motion} from 'framer-motion'; 

import {fadeIn} from '../variants' 

import Img1 from '../assets/portfolio-img1.png'
import Img2 from '../assets/portfolio-img2.png'
import img3 from '../assets/portfolio-img3.png'
import Work4 from '../assets/Work4.png'
import Work5 from '../assets/Work5.png'
import Work6 from '../assets/Work6.png'


const Work = () => {
  return <section className='section' id='work'>
        <div className='container mx-auto'>
          <div className='flex flex-col lg:flex-row gap-x-10'>
            <motion.div 
            
            variants={fadeIn('right', 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{once: false, amount: 0.3}}
            className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
              {/*text*/}
              <div>
                <h2 className='h2 leading-tight text-accent'>
                  My latest <br/>
                  Work.
                </h2>
                <p className='max-w-sm mb-16'>Here are some of my most recent  Projects , that i have been working on . This is an example of what my Work looks like , so you can have a better understanding of what you are getting 
                </p>
                <button className='btn btn-sm '><Link to="/Projects">View all Projects</Link> </button>
              </div>  
              {/*image*/}  
               <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                   {/*overlay*/}
                  <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                  {/* img */}
                  <img className='group-hover:scale-125 transition-all duration-500' src={Img1} alt='' />
                  {/* prettitle */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                   <span className='text-gradient'>Web develpment/ Design</span> 
                  </div>
                  {/* title */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                    <span className='text-3x1 text-white font-bold '>3d scrollable test Website</span>
                  </div>
               </div>     
              </motion.div>
              <motion.div className='flex-1 flex flex-col gap-y-10' 
            variants={fadeIn('left', 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{once: false, amount: 0.3}}
            >
              {/*image*/}
              <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                   {/*overlay*/}
                  <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                  {/* img */}
                  <img className='group-hover:scale-125 transition-all duration-500' src={Work6} alt='' />
                  {/* prettitle */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                   <span className='text-gradient'>themed Chatgpt clone</span> 
                  </div>
                  {/* title */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                    <span className='text-3x1 text-white font-bold '><a className='hover' href='https://ultimate-gpt-three.vercel.app/'>visit</a></span>
                  </div>
               </div> 
               <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                   {/*overlay*/}
                  <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                  {/* img */}
                  <img className='group-hover:scale-125 transition-all duration-500' src={img3} alt='' />
                  {/* prettitle */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                   <span className='text-gradient'>Game Design</span> 
                  </div>
                  {/* title */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                    <span className='text-3x1 text-white font-bold '>Robot shooter</span>
                  </div>
               </div>     
            </motion.div>
          </div>
          <div className='h-[50px]'></div>
          
          <div className='flex flex-col lg:flex-row gap-x-10'>
            <motion.div variants={fadeIn('right', 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{once: false, amount: 0.3}}>
          <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                   {/*overlay*/}
                  <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                  {/* img */}
                  <img className='group-hover:scale-125 transition-all duration-500' src={Work4} alt='' />
                  {/* prettitle */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                   <span className='text-gradient'>Firebase Chatapp</span> 
                  </div>
                  {/* title */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                    <span className='text-3x1 text-white font-bold '><a className='hover' href='https://coolchatappjl.web.app/'>visit</a></span>
                  </div>
               </div>     
            </motion.div>
            <motion.div variants={fadeIn('left', 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{once: false, amount: 0.3}}>
          <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                   {/*overlay*/}
                  <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                  {/* img */}
                  <img className='group-hover:scale-125 transition-all duration-500' src={Work5} alt='' />
                  {/* prettitle */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                   <span className='text-gradient'>Website for Roofing company</span> 
                  </div>
                  {/* title */}
                  <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                    <span className='text-3x1 text-white font-bold '> <a className='hover' href='https://www.behrend-dach.de/'>visit</a></span>
                  </div>
               </div>     
            </motion.div>
          </div>
        </div>
    </section>;
};

export default Work;
